import { DropDownItemType } from 'common/components/drop-downs/legacy/dropDownItemType';
import { AttributionModelTypes } from 'common/constants/attribution-model-types';

export const attributeModelDropDownRoutes = [
  {
    key: AttributionModelTypes.FirstClick,
    label: 'First Click',
    isActive: true
  },
  {
    key: AttributionModelTypes.LastClick,
    label: 'Last Click',
    isActive: false
  },
  { key: AttributionModelTypes.Linear, label: 'Linear', isActive: false },
  {
    key: AttributionModelTypes.PositionBased,
    label: 'Position Based',
    isActive: false
  },
  {
    key: AttributionModelTypes.TimeDecay,
    label: 'Time Decay',
    isActive: false
  },
  {
    key: AttributionModelTypes.Impressions,
    label: 'DDA & Impressions',
    isActive: false
  }
] as DropDownItemType[];
